import apiClient from '@/axios';


const BASE_URL = 'https://pulsapp.kz/';


export const getVerify = async () => {
    try {
      const response = await apiClient.get('/admin/to-verify');
      return response.data.pending_doctors.concat(response.data.pending_nurses).map(application => ({
        ...application,
        certificates: application.certificates
          ? application.certificates.map(cert => `${BASE_URL}/storage/${cert}`)
          : [],
      }));
    } catch (error) {
      console.error('Ошибка при получении заявок:', error);
      throw error;
    }
  };


  export async function resetUpdateIndicator(applicationId) {
    try {
      const response = await apiClient.patch(`/admin/reset-indicator/${applicationId}`);
      return response.data;
    } catch (error) {
      console.error('Ошибка при сбросе индикации обновления:', error);
      throw error;
    }
  }



  export async function deleteApplicationById(adminId) {
    return await apiClient.delete(`/admin/delete-admin/${adminId}`);
  }


  export async function confirmApplicationById(applicationId, type) {
    try {
      const response = await apiClient.post(`/admin/confirm-application/${applicationId}`, {
        type,
      });
      return response.data;
    } catch (error) {
      console.error('Ошибка при подтверждении заявки:', error);
      throw error;
    }
  }


  export async function rejectApplicationById(applicationId, reason, type) {
    return await apiClient.post(`/admin/reject-application/${applicationId}`, {
      reason,
      type,
    });
  }
  export async function sendDocument(applicationId, type) {
    try {
      const response = await apiClient.post(`/admin/contract/${applicationId}`, {
        type,
      });
      return response.data;
    } catch (error) {
      console.error('Ошибка при отправке документа:', error);
      throw error;
    }
  }